import React, { useState } from "react"
import Logo from "./logo"
import NavbarLink from "./navbarLink"
import LangIcon from './langIcon';

const Hamburger = ({ coverOption, options,language,onChange }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="hamburger-container">
      <Logo {...coverOption} />

      <div
        className="hamburger-container-burger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="hamburger-container-burger-burgerBox">
          <div
            className={
              isOpen
                ? "hamburger-container-burger-burgerBox-innerOpen"
                : "hamburger-container-burger-burgerBox-inner"
            }
          ></div>
        </div>
      </div>
      {isOpen ? (
        <div className={isOpen  ?  "hamburger-container-contentOpen" : "hamburger-container-content"}>
          {options.map((option, i) => {
            return <NavbarLink key={i} {...option} />
          })}
          <LangIcon language={language}
                      onChange={onChange} />
        </div>
      ) : (
        ""
      )}
    </div>
  )
}

export default Hamburger
